// 传奇角色的完整剧本/房间定义优先；只有{id}引用才查本地表。
// 不创建第二套传奇区域，也不改变角色发送、身份或阵营规则。
export const resolveFabledRole = (role, definitions) =>
  role && role.team === "fabled" && role.name
    ? role
    : definitions.get(typeof role === "string" ? role : role?.id) || role;

export const usesScriptFabledImage = (role) =>
  !!(role && role.team === "fabled" && role.isCustom && role.image);
